"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var genFeed = function (document) {
    var titleEl = document.querySelector('channel > title');
    var descriptionEl = document.querySelector('channel > description');
    var title = titleEl.textContent;
    var description = descriptionEl.textContent;
    var feed = { title: title, description: description };
    return feed;
};
var genPosts = function (document) {
    var itemsEl = document.querySelectorAll('item');
    var posts = Array.from(itemsEl).map(function (item) {
        var titleEl = item.querySelector('title');
        var descriptionEl = item.querySelector('description');
        var linkEl = item.querySelector('link');
        var title = titleEl === null || titleEl === void 0 ? void 0 : titleEl.textContent;
        var description = descriptionEl === null || descriptionEl === void 0 ? void 0 : descriptionEl.textContent;
        var link = linkEl === null || linkEl === void 0 ? void 0 : linkEl.textContent;
        return { title: title, description: description, link: link };
    });
    return posts;
};
exports.default = (function (data) {
    var parsedDom = new DOMParser();
    var parsedDocument = parsedDom.parseFromString(data, 'application/xml');
    var errorNode = parsedDocument.querySelector('parsererror');
    if (errorNode) {
        throw new Error('parsingFailed');
    }
    var feed = genFeed(parsedDocument);
    var posts = genPosts(parsedDocument);
    var parsedData = { feed: feed, posts: posts };
    return parsedData;
});
